(ns app.front.view.admin.migration.activate-verified-properties
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/activate-verified-properties
    :title     "Set verified properties active"
    :help-text (str "This task sets domain state active to properties that have a verified id "
                    "but are still in unverified state.")}
   match])

(def route
  {:name        :view/admin.migration.activate-verified-properties
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/activate-verified-properties]))}]})
